import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';

import NotAvailableStatus from '@/components/theme/not-available-status';

interface DigitalKeysNotAvailable {
  noRoomAssigned: boolean;
  defaultCheckInTime?: string;
  arrivingToday?: boolean;
}

export const DigitalKeysNotAvailable = ({
  noRoomAssigned,
  defaultCheckInTime,
  arrivingToday,
}: DigitalKeysNotAvailable) => {
  const intl = useIntl();

  const getStatusMessage = useCallback(() => {
    if (noRoomAssigned) {
      return intl.formatMessage({
        id: 'digital_keys/available_on_room_assignment',
        defaultMessage: 'Digital keys available once a room has been assigned.',
      });
    }

    if (arrivingToday) {
      return intl.formatMessage(
        {
          id: 'digital_keys/available_on_time',
          defaultMessage: 'Digital Keys available at {time}.',
        },
        {
          time: defaultCheckInTime,
        },
      );
    }

    return intl.formatMessage({
      id: 'digital_keys/available_on_arrival',
      defaultMessage: 'Digital Keys available on arrival day.',
    });
  }, [arrivingToday, defaultCheckInTime, intl, noRoomAssigned]);

  return <NotAvailableStatus label={getStatusMessage()} />;
};
